  <form>
    <div class="row">
      <div class="col-md-12 col-xl-12">
        <div class="table-responsive our-table">
          <table class="table table-striped text-nowrap mb-0">
            <thead class="border-top">
              <tr>
                <th class="text-capitalize">
                  {{ "common.accountId" | translate }}
                </th>
                <th class="text-capitalize">
                  {{ "common.accountHolder" | translate }}
                </th>
                <th class="text-capitalize">
                  {{ "common.bank" | translate }}
                </th>
                <th class="text-capitalize">
                  {{ "common.availableBalance" | translate }}
                </th>
                <th class="text-capitalize">
                  {{ "common.actions" | translate }}
                </th>
              </tr>
            </thead>
            
            <tbody>
              <tr class="border-bottom" *ngFor="let acc of accounts">
                <td>
                  <span>{{ acc.accountId }}</span>
                </td>
                <td>
                  <span>{{ acc.razaoSocial }}</span>
                </td>
                <td>
                  <span>{{ acc.bankName }}</span>
                </td>
                <td>
                  <span>{{acc.readyAmount | formatCurrency}}</span>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm btn-pill btn-md our-button px-2"
                    (click)="onSwitchAccount(acc.accountId)"
                    [disabled]="switchingId === acc.id"
                  >
                    <i class="fe fe-log-in me-1"></i>
                    {{
                      switchingId === acc.accountId
                        ? ("common.loading" | translate)
                        : ("common.switch" | translate)
                    }}
                  </button>
                </td>
              </tr>

              <tr *ngIf="accounts.length == 0">
                <td colspan="7">{{ "common.noData" | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </form>

  <ng-template #requestTOTPCode let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Informe o token de autenticação</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click'); isLoaded = true"
      ></button>
    </div>

    <div class="modal-body">
      <div class="form-group mt-2">
        <p *ngIf="errorMessage.length > 0" class="text-danger">
          {{ errorMessage }}
        </p>
      </div>

      <div class="form-group mb-3">
        <input
          type="text"
          class="form-control"
          id="authToken"
          placeholder="Token"
          [(ngModel)]="validationCode"
          (keyup.enter)="validateTotp()"
        />
        <button
          (click)="pasteTotpCode()"
          class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
        >
          {{ "login.totp.pasteButton" | translate }}
        </button>
      </div>
    </div>

    <div class="modal-footer text-center">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="validateTotp()"
        [disabled]="validatingTotp"
      >
        VALIDAR
      </button>
    </div>
  </ng-template>
